export default __webpack_public_path__ + "static/media/single-both-border-right.de205d7d.svg";